<template>
    <app-dialog :title="tb('Política de privacidade')" :subtitle="tb('Consulte os termos de uso e privacidade da plataforma myProvet')" v-bind="$attrs" @input="onDialogInput">
        <template v-slot:content>
            <v-progress-circular v-if="!privacyPolicy" indeterminate></v-progress-circular>

            <p v-else class="font-size-md mx-1 description-text" v-html="tHtml(privacyPolicy)"></p>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text class="myprovet-btn-ok" @click="onCloseDialog" data-cy="app-dialog-confirm-btn">{{ tb('Fechar') }}</v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { axios } from '@/Services/Backend';

export default {
    props: {
        //
    },

    data() {
        return {
            privacyPolicy: null,
        };
    },

    created() {
        axios
            .get('/api/privacy-policy')
            .then((response) => {
                this.privacyPolicy = response.data;
            })
            .catch((error) => {
                this.$emit('onCancel', false);
                this.showError(this.$t('toasts.privacyPolicyError'));
            });
    },

    methods: {
        onCloseDialog() {
            this.$emit('onCancel', false);
        },
        onDialogInput(event) {
            if (!event) {
                this.$emit('onCancel', false);
            }
        },
    },
};
</script>
